import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default {
  create(i18n) {
    let router = new Router({
      routes: [
        {
          path: '/',
          name: 'Message',
          component: () => import('./views/Message.vue'),
          meta: {
            title: 'message',
          }
        }
      ]
    });
    router.beforeEach((to, from, next) => {
      document.title = i18n.t(to.meta.title).name;
      next();
    });
    return router;
  }
};